<template>
  <div>
    <div class="py-7.5 grid md:grid-cols-2 lg:grid-cols-3 gap-4 xl:gap-10">
      <div
        v-for="(card, index) in cards"
        :key="`my-card-${index}`"
        class="p-7.5 bg-white border border-dark-b rounded-lg"
      >
        <p class="font-bold text-2xl">{{ getUserAuthInfo.name }}</p>
        <div class="py-5">
          <p>**** **** **** {{ card.last4Digits }}</p>
          <p>{{card.expMonth}} / {{ card.expYear }}</p>
        </div>
        <p class="uppercase font-bold">{{ card.brand }}</p>
        <div class="pt-5">
          <button
            :disabled="deleteCardActive"
            class="flex delete-stripe-card items-center text-sm text-dark"
            @click="deleteCard(card.id)"
          >
            <i class="icon-remove mr-2" />
            <span class="opacity-50 pt-1">Remove</span>
          </button>
        </div>
      </div>
      <button
        class="bg-white border border-dark-b rounded-lg flex items-center justify-center py-20"
        @click="isCardModalOpen = true"
      >
        <div class="leading-6 text-blue font-medium text-xl">
          <p>+</p><p>Add New</p><p>Card</p>
        </div>
      </button>
    </div>
    <NewCardModal v-if="isCardModalOpen" @close="closeModal" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import NewCardModal from '@/shared/components/profile/payment/NewCardModal'

export default {
  name: 'CardPayment',
  props: {
    cards: {
      type: Array
    }
  },
  data() {
    return {
      isCardModalOpen: false,
      deleteCardActive: false
    }
  },
  components: {
    NewCardModal
  },
  computed: {
    ...mapGetters ([
      'getUserAuthInfo'
    ])
  },
  methods: {
    ...mapActions ([
      'deleteBuyerCard'
    ]),
    closeModal(card) {
      this.isCardModalOpen = false
      if (card) this.$emit('fetchCards')
    },
    async deleteCard(id) {
      if(this.deleteCardActive) return
      this.deleteCardActive = true;
      const response = await this.deleteBuyerCard(id)
      if (response.result) {
        this.$emit('fetchCards')
      } else {        
        this.deleteCardActive = false;
      }
      this.$notify({
        group: 'buyHive',
        type: response.result ? 'success' : 'error',
        text: response.message,
        duration: 7000
      })
    }
  }
}
</script>
